import { BankAccountSubType } from 'services/hurdlr/queries/useHurdlrPlaidItems/useHurdlrPlaidItems.interface';

const bankAccountLabels: Record<BankAccountSubType, string> = {
    [BankAccountSubType.Checking]: 'Checking',
    [BankAccountSubType.Savings]: 'Savings',
    [BankAccountSubType.Hsa]: 'Health Savings',
    [BankAccountSubType.Cd]: 'Certificate of Deposit',
    [BankAccountSubType.MoneyMarket]: 'Money Market',
    [BankAccountSubType.CreditCard]: 'Credit Card',
    [BankAccountSubType.Paypal]: 'PayPal',
    [BankAccountSubType.Prepaid]: 'Prepaid Debit Card',
    [BankAccountSubType.CashManagement]: 'Cash Management',
    [BankAccountSubType.Ebt]: 'Electronic Benefit Transfer (EBT)',
};

export default bankAccountLabels;
